module.exports = __webpack_public_path__ + "static/media/PlutoBold.e636c41c.eot";